document.documentElement.classList.remove('no-js');
document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[data-menu-toggle]');
  const nav = document.querySelector('[data-mobile-nav]');
  if (toggle && nav) {
    toggle.addEventListener('click', () => {
      const open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      nav.hidden = open;
    });
  }

  const FAVOURITES_KEY = 'lav:favourites';

  function readFavourites() {
    try {
      const stored = JSON.parse(localStorage.getItem(FAVOURITES_KEY));
      return Array.isArray(stored) ? stored.filter((h) => typeof h === 'string') : [];
    } catch (error) {
      return [];
    }
  }

  function writeFavourites(list) {
    try {
      localStorage.setItem(FAVOURITES_KEY, JSON.stringify(list));
    } catch (error) {
      /* private browsing, or storage full: the page still works, nothing persists */
    }
  }

  function paintFavourite(button, saved) {
    const title = button.dataset.favouriteTitle || 'această piesă';
    button.setAttribute('aria-pressed', saved ? 'true' : 'false');
    button.setAttribute('aria-label', (saved ? 'Elimină ' : 'Adaugă ') + title + (saved ? ' din favorite' : ' la favorite'));
  }

  function paintFavouriteCount(list) {
    document.querySelectorAll('[data-favourite-count]').forEach((el) => { el.textContent = String(list.length); });
    document.querySelectorAll('[data-favourite-link]').forEach((el) => { el.hidden = list.length === 0; });
  }

  function syncFavourites(root) {
    const list = readFavourites();
    (root || document).querySelectorAll('[data-favourite]').forEach((button) => {
      paintFavourite(button, list.indexOf(button.dataset.favourite) !== -1);
    });
    paintFavouriteCount(list);
    return list;
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-favourite]');
    if (!button) return;
    event.preventDefault();
    const handle = button.dataset.favourite;
    const list = readFavourites();
    const at = list.indexOf(handle);
    if (at === -1) list.unshift(handle);
    else list.splice(at, 1);
    writeFavourites(list);
    document.querySelectorAll('[data-favourite="' + handle + '"]').forEach((el) => paintFavourite(el, at === -1));
    paintFavouriteCount(list);
    const card = button.closest('[data-favourites-grid] .product-card');
    if (card && at !== -1) {
      card.remove();
      renderFavouritesPage();
    }
  });

  const favouritesPage = document.querySelector('[data-favourites-page]');

  async function renderFavouritesPage() {
    if (!favouritesPage) return;
    const grid = favouritesPage.querySelector('[data-favourites-grid]');
    const empty = favouritesPage.querySelector('[data-favourites-empty]');
    const loading = favouritesPage.querySelector('[data-favourites-loading]');
    const label = favouritesPage.querySelector('[data-favourites-count-label]');
    const note = favouritesPage.querySelector('[data-favourites-note]');
    let list = readFavourites();

    if (grid.childElementCount !== list.length) {
      const cards = await Promise.all(list.map((handle) =>
        fetch('/products/' + encodeURIComponent(handle) + '?view=card')
          .then((response) => (response.ok ? response.text() : null))
          .catch(() => null)
      ));
      const kept = [];
      grid.innerHTML = '';
      cards.forEach((html, i) => {
        if (!html) return;
        kept.push(list[i]);
        grid.insertAdjacentHTML('beforeend', html);
      });
      if (kept.length !== list.length) writeFavourites(kept);
      list = kept;
    }

    loading.hidden = true;
    grid.hidden = list.length === 0;
    empty.hidden = list.length > 0;
    note.hidden = list.length === 0;
    label.textContent = list.length ? list.length + (list.length === 1 ? ' PIESĂ SALVATĂ' : ' PIESE SALVATE') : '';
    syncFavourites(grid);
  }

  syncFavourites();
  renderFavouritesPage();

  document.querySelectorAll('[data-random-pool]').forEach((grid) => {
    const extras = grid.querySelector('template');
    if (!extras) return;
    const shown = Array.from(grid.children).filter((el) => el !== extras);
    const pool = shown.concat(Array.from(extras.content.children));
    extras.remove();
    for (let i = pool.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      const swap = pool[i];
      pool[i] = pool[j];
      pool[j] = swap;
    }
    grid.replaceChildren.apply(grid, pool.slice(0, shown.length));
    syncFavourites(grid);
  });

  const cartForm = document.querySelector('[data-cart-form]');
  if (cartForm) {
    const fields = Array.from(cartForm.querySelectorAll('[data-cart-qty]'));
    cartForm.setAttribute('novalidate', 'novalidate');

    function problem(input) {
      const value = input.value.trim();
      if (!/^\d+$/.test(value)) return 'Introdu o cantitate \u00eentreag\u0103.';
      const max = Number(input.max);
      if (!input.max || Number(value) <= max) return '';
      if (max === 0) return 'Aceast\u0103 pies\u0103 nu mai este disponibil\u0103.';
      if (max === 1) return 'Aceast\u0103 pies\u0103 este disponibil\u0103 \u00eentr-un singur exemplar.';
      return 'Sunt disponibile doar ' + max + ' exemplare.';
    }

    function check(input) {
      const note = input.closest('.cart-line').querySelector('[data-cart-error]');
      const text = problem(input);
      note.textContent = text;
      note.hidden = !text;
      input.classList.toggle('is-invalid', Boolean(text));
      input.setAttribute('aria-invalid', text ? 'true' : 'false');
      return !text;
    }

    fields.forEach((input) => input.addEventListener('input', () => {
      if (input.getAttribute('aria-invalid') === 'true') check(input);
    }));

    cartForm.addEventListener('submit', (event) => {
      const invalid = fields.filter((input) => !check(input));
      if (!invalid.length) return;
      event.preventDefault();
      invalid[0].focus();
    });
  }

  document.querySelectorAll('[data-notify-stock]').forEach((wrap) => {
    const form = wrap.querySelector('[data-notify-form]');
    const status = wrap.querySelector('[data-notify-status]');
    if (!form || !status) return;
    form.addEventListener('submit', (event) => {
      event.preventDefault();
      const trap = form.querySelector('[data-notify-hp]');
      const button = form.querySelector('button');
      button.disabled = true;
      const done = () => {
        form.hidden = true;
        status.textContent = wrap.dataset.notifySuccess;
        status.hidden = false;
      };
      if (trap && trap.value) { done(); return; }
      fetch(form.action, { method: 'POST', mode: 'no-cors', body: new FormData(form) }).catch(() => {}).finally(done);
    });
  });

  document.querySelectorAll('.product-media').forEach((frame) => {
    const media = frame.querySelector('img');
    if (!media || (media.complete && media.naturalWidth)) return;
    frame.classList.add('is-loading');
    const settled = () => frame.classList.remove('is-loading');
    media.addEventListener('load', settled, { once: true });
    media.addEventListener('error', settled, { once: true });
  });

  const box = document.querySelector('[data-lightbox]');
  const items = Array.from(document.querySelectorAll('[data-lightbox-item]'));
  if (!box || !items.length) return;

  const stage = box.querySelector('[data-lightbox-stage]');
  const image = box.querySelector('[data-lightbox-image]');
  const level = box.querySelector('[data-lightbox-level]');
  const counter = box.querySelector('[data-lightbox-index]');
  const closeButton = box.querySelector('.lightbox__close');
  const zoomButtons = Array.from(box.querySelectorAll('[data-lightbox-zoom]'));
  const MIN = 1;
  const MAX = 5;
  const STEP = 1.5;
  let index = 0;
  let scale = 1;
  let x = 0;
  let y = 0;
  let opener = null;

  const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

  function apply() {
    const frame = stage.getBoundingClientRect();
    const maxX = Math.max(0, (image.clientWidth * scale - frame.width) / 2);
    const maxY = Math.max(0, (image.clientHeight * scale - frame.height) / 2);
    x = clamp(x, -maxX, maxX);
    y = clamp(y, -maxY, maxY);
    image.style.transform = 'translate(' + x + 'px,' + y + 'px) scale(' + scale + ')';
    box.classList.toggle('is-zoomed', scale > 1);
    if (level) level.textContent = Math.round(scale * 100) + '%';
    zoomButtons.forEach((button) => {
      button.disabled = button.dataset.lightboxZoom === '1' ? scale >= MAX : scale <= MIN;
    });
  }

  function setScale(next, originX, originY) {
    const previous = scale;
    scale = clamp(next, MIN, MAX);
    if (scale === previous) return;
    if (originX === undefined) {
      x *= scale / previous;
      y *= scale / previous;
    } else {
      const frame = stage.getBoundingClientRect();
      const pointX = originX - (frame.left + frame.width / 2);
      const pointY = originY - (frame.top + frame.height / 2);
      x = pointX - (pointX - x) * (scale / previous);
      y = pointY - (pointY - y) * (scale / previous);
    }
    apply();
  }

  function loaded() {
    box.classList.remove('is-loading');
  }

  function show(next) {
    index = (next + items.length) % items.length;
    const item = items[index];
    box.classList.add('is-loading');
    image.src = item.dataset.full;
    image.alt = item.dataset.alt || '';
    if (image.complete && image.naturalWidth) loaded();
    scale = 1;
    x = 0;
    y = 0;
    apply();
    if (counter) counter.textContent = String(index + 1);
  }

  function open(next) {
    opener = items[next];
    show(next);
    box.hidden = false;
    document.body.classList.add('lightbox-open');
    if (closeButton) closeButton.focus();
  }

  function close() {
    box.hidden = true;
    document.body.classList.remove('lightbox-open');
    if (opener) opener.focus();
  }

  image.addEventListener('load', loaded);
  image.addEventListener('error', loaded);

  items.forEach((item, i) => item.addEventListener('click', () => open(i)));

  box.addEventListener('click', (event) => {
    const step = event.target.closest('[data-lightbox-step]');
    if (step) { show(index + Number(step.dataset.lightboxStep)); return; }
    const zoom = event.target.closest('[data-lightbox-zoom]');
    if (zoom) { setScale(Number(zoom.dataset.lightboxZoom) === 1 ? scale * STEP : scale / STEP); return; }
    if (event.target.closest('[data-lightbox-close]')) { close(); return; }
    if (!moved && event.target !== image && !event.target.closest('button')) close();
    moved = false;
  });

  stage.addEventListener('dblclick', (event) => {
    if (scale > MIN) setScale(MIN);
    else setScale(2.5, event.clientX, event.clientY);
  });

  stage.addEventListener('wheel', (event) => {
    event.preventDefault();
    setScale(scale * (event.deltaY < 0 ? 1.18 : 1 / 1.18), event.clientX, event.clientY);
  }, { passive: false });

  document.addEventListener('keydown', (event) => {
    if (box.hidden) return;
    if (event.key === 'Escape') close();
    else if (event.key === 'ArrowRight') show(index + 1);
    else if (event.key === 'ArrowLeft') show(index - 1);
    else if (event.key === '+' || event.key === '=') setScale(scale * STEP);
    else if (event.key === '-') setScale(scale / STEP);
    else return;
    event.preventDefault();
  });

  const pointers = new Map();
  let pinchDistance = 0;
  let pinchScale = 1;
  let last = null;
  let start = null;
  let moved = false;

  const centre = () => {
    const points = Array.from(pointers.values());
    return { x: (points[0].x + points[1].x) / 2, y: (points[0].y + points[1].y) / 2, d: Math.hypot(points[0].x - points[1].x, points[0].y - points[1].y) };
  };

  stage.addEventListener('pointerdown', (event) => {
    if (event.target.closest('button')) return;
    stage.setPointerCapture(event.pointerId);
    pointers.set(event.pointerId, { x: event.clientX, y: event.clientY });
    if (pointers.size === 2) { const c = centre(); pinchDistance = c.d; pinchScale = scale; }
    last = { x: event.clientX, y: event.clientY };
    start = { x: event.clientX, y: event.clientY };
    moved = false;
    box.classList.add('is-panning');
  });

  stage.addEventListener('pointermove', (event) => {
    if (!pointers.has(event.pointerId)) return;
    pointers.set(event.pointerId, { x: event.clientX, y: event.clientY });
    if (pointers.size === 2) {
      const c = centre();
      moved = true;
      if (pinchDistance) setScale(pinchScale * (c.d / pinchDistance), c.x, c.y);
      return;
    }
    if (start && Math.hypot(event.clientX - start.x, event.clientY - start.y) > 3) moved = true;
    if (scale > MIN && last) {
      x += event.clientX - last.x;
      y += event.clientY - last.y;
      last = { x: event.clientX, y: event.clientY };
      apply();
    }
  });

  ['pointerup', 'pointercancel'].forEach((type) => stage.addEventListener(type, (event) => {
    pointers.delete(event.pointerId);
    if (pointers.size < 2) pinchDistance = 0;
    const remaining = pointers.values().next().value;
    last = remaining ? { x: remaining.x, y: remaining.y } : null;
    if (!pointers.size) box.classList.remove('is-panning');
  }));

  ['gesturestart', 'gesturechange', 'gestureend'].forEach((type) => stage.addEventListener(type, (event) => event.preventDefault()));

  window.addEventListener('resize', () => { if (!box.hidden) apply(); });
});
